const $ = require('jquery')

const { BREAKPOINT, SELECTOR } = require('./api')
const CampaignTimer = require('./campaignTimer')
const isMobile = require('./isMobile')

// =========================================================================
// Base function for sliders
// =========================================================================
const mainSlider = {
  init () {
    // Init sliders
    const $nav = $('.main-slider__nav')
    const slideIntervalDuration = parseInt(SELECTOR.MAIN_SLIDER.attr('data-slide-duration')) || 5000
    let slideEventCompleted = false

    $(document).on('readystatechange', function() {
      if (document.readyState === 'complete') {
        if ($('.stage_experienceEdit').length) {
          SELECTOR.MAIN_SLIDER.carousel('pause')
        } else {
          SELECTOR.MAIN_SLIDER.carousel({
            interval: slideIntervalDuration,
          }).hover(function() {
            $(this).carousel('pause')
          }, function() {
            $(this).carousel('cycle')
          }).on('swiperight', function() {
            $(this).carousel('prev')
          }).on('swipeleft', function() {
            $(this).carousel('next')
          }).on('slide.bs.carousel', function() {
            if (isMobile.any() || window.innerWidth < BREAKPOINT.TABLET) {
              const video = $('video')
              video.trigger('pause')
              video.currentTime = 0
              video.load()
            }
          })
        }
      }
    })

    $nav.find('.right').on('click', function() {
      SELECTOR.MAIN_SLIDER.carousel('next')
    })
    $nav.find('.left').on('click', function() {
      SELECTOR.MAIN_SLIDER.carousel('prev')
    })

    // Small integration with CampaignTimer component
    SELECTOR.MAIN_SLIDER.bind('slid.bs.carousel', function() {
      if (CampaignTimer !== null) {
        if (slideEventCompleted === false && CampaignTimer.timerBarState === true && CampaignTimer.pageScrolled === false) {
          slideEventCompleted = true
          CampaignTimer.pageScrolled = true
          if (window.innerWidth < BREAKPOINT.TABLET) {
            return CampaignTimer.hideCampaignTimer()
          }
        }
      }

      return null
    })
  },
  addSwipe () {
    if (SELECTOR.MAIN_SLIDER.exists()) {
      if (window.innerWidth < BREAKPOINT.DESKTOP && isMobile.any()) {
        const $slider = new Hammer(SELECTOR.MAIN_SLIDER.get(0))
        $slider.on('swiperight', function() {
          SELECTOR.MAIN_SLIDER.carousel('prev')
        }).on('swipeleft', function() {
          SELECTOR.MAIN_SLIDER.carousel('next')
        })
      }
    }
  },
  toggleAutoplay () {
    if (isMobile.any() || window.innerWidth < BREAKPOINT.TABLET) {
      SELECTOR.MAIN_SLIDER.find($('video')).each(function() {
        $(this).attr('controls', '')
        $(this).removeAttr('autoplay')
        $(this).removeAttr('loop')
      })
    } else {
      SELECTOR.MAIN_SLIDER.find($('video')).each(function() {
        $(this).attr('autoplay', '')
        $(this).attr('loop', '')
        $(this).removeAttr('controls')
      })
    }
  },
}

module.exports = mainSlider



// WEBPACK FOOTER //
// ./src/modules/mainSlider.js